import {useNavigate, useLocation} from "react-router";
import {useEffect, useState} from "react";
import {useUser} from "@/hooks/useUser.ts";
import {api} from "@/lib/utils.ts";
import {LoginResponse} from "@/store/session.ts";
import {authApi} from "@/store/auth.ts";
import {store, useDispatch} from "@/store";
import {RegisterData} from "@/pages/auth/RegisterPage.tsx";
import {RegisterResponse} from "@/lib/auth.ts";

export function useGuestPage() {

    const {user, isLoadingUser} = useUser();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [isLogining, setIsLogining] = useState(false);

    const isLoading = isLoadingUser || isLogining;

    async function login(certificates: { username: string, password: string }) {
        setIsLogining(true);
        return await api.post<LoginResponse>('auth/login/', certificates)
            .then(response => {
                if (response.data.status === 'OK') {
                   dispatch(authApi.util.resetApiState());
                }
                return response;
            }).catch(error => {
                throw error;
            }).finally(() => setIsLogining(false));
    }

    useEffect(() => {
        if (user) {
            const next = new URLSearchParams(location.search).get('next');
            if (next) {
                window.location.href = next;
            } else {
                navigate('/', {replace: true, viewTransition: true});
            }
        }
    }, [user]);

    async function register(data: RegisterData) {
        return await api.post<RegisterResponse>('user/register/', data)
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    }

    return {
        isLoggedIn: !!user,
        login,
        isLoading,
        register
    };
}